import type { GetDashboardSummary200Summary } from './getDashboardSummary200Summary';

export type GetDashboardSummary200 = {
  message?: string;
  success: boolean;
  summary?: GetDashboardSummary200Summary;
};
